import React from 'react'
import Link from 'gatsby-link'
import StoreLinks from "../components/storeLinks";
import IntroParagraph from "../components/IntroParagraph";

import elm from "../content/elm.json";
import Quiz from "../components/Quiz";
import Resources from "../components/Resources";
import SampleChapters from "../components/SampleChapters";

import appImg from "../img/elm-acc-app.png"

const bookTitle = "Elm Accelerated";

export default () => (
  <div>
    <h1 className="elm">{bookTitle}</h1>
    <IntroParagraph />

    <div style={{ display: "flex", flexDirection: "row"}}>
      <img src={appImg} style={{ width: 125, height: 187.5, maxWidth: "inherit"}} />

      <div style={{flex: 2}}>
        <h2>Apps</h2>

        <p>The primary version of Elm Accelerated is the App. Currently the App is out on iOS.</p>

        <StoreLinks iOSStoreLink="https://itunes.apple.com/us/app/elm-accelerated/id1303935533?ls=1&mt=8"/>

        <p>But on this site you can also find:</p>

        <ul>
          <li><a href="#quiz">A quick Elm quiz to rate your current knowledge</a></li>
          <li><a href="#sample">Sample book chapters</a></li>
          <li><a href="#resources">Links to external resources on learning Elm</a></li>
        </ul>

      </div>
    </div>

    <h1 id="quiz">Quiz</h1>

    <p>Let's rate your Elm knowledge. Once you have used the Elm Accelerated App for a while you should be able to
      answer all of these (and similar) questions with relative ease.</p>

    <Quiz questions={elm.questions} bookTitle={bookTitle}/>

    <SampleChapters chapters={elm.excerpts} />

    <Resources resources={elm.resources} bookTitle={bookTitle}/>
  </div>
)


// WEBPACK FOOTER //
// ./src/pages/elm.js